export function debounce(callback, wait) {
	let handle
	function debounce() {
		cancel()
		handle = setTimeout(() => callback.apply(this, arguments), wait)
	}
	function immediate() {
		cancel()
		return callback.apply(this, arguments)
	}
	function cancel() {
		handle && clearTimeout(handle)
		handle = undefined
	}
	debounce.cancel = cancel
	debounce.immediate = immediate
	debounce.debounce = debounce
	return debounce
}